// @ts-nocheck
import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Form, Button, Row, Col, Select, Spin } from 'antd';

//API
import { fetchMessageListAPI } from 'services/shared/fetchLovList';
import {
	fetchParams,
	fetchGeneratedReports,
	generateArPerClient,
	generateArSummary,
	generateBirSalesRep,
	generateColRepPerClient,
	generateColRepPerMonth,
	generateColRepPerWeek,
	generateColRepSummary,
	generateOrSeries,
	generateDrSeries,
	generateRepAgentPerMonth,
	generateSalesRepPerClientMonth,
	generateSalesRepPerMonthBr,
	generateSoa,
	generateSalesRepPerAgentMonth,
	generateColRepPerPayDate,
	generateArAging,
	generateAr,
	generateArAgingPerClient,
	generateColReport,
	generateSalesReport,
	generateUnbilledDr,
	generateDrClientDelivery,
	generateConsolidatedDateRange,
	generateConsolidatedCustomer,
	generateConsolidatedAgent,
	generateArSummArPerClientCombined
} from 'services/accounting_reports/accounting_reports';

import { fetchAccountingReportsAccessList } from 'services/system_setup/reportAccess';

import SearchLov from './getLov';
import SearchReportTable from './searchReportTable';

//USER DETAILS
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

//MESSAGE PROMPTS
import Message from 'shared_components/message';
import { logAuditTrailEvent } from 'services/system_setup/auditTrail';

//OTHERS
import moment from 'moment';
import { set } from 'lodash';
const { Text } = Typography;
const { Option } = Select;

function SearchReportForm(props) {
    const [form] = Form.useForm();
	const { onFinish } = props;
	const navigate = useHistory();
	const formRef = useRef();
	const [loading, setLoading] = useState(false);
	const [loadingMessage, setLoadingMessage] = useState('Loading reports...');
	const [reportType, setReportType] = useState();
	const [selectedReportPrefix, setSelectedReportPrefix] = useState('');
	const [messagesList, setMessagesList] = useState([]);
	const [reportsList, setReportsList] = useState([]);
	const [params, setParams] = useState([]);
	const [customerLabel, setcustomerLabel] = useState([]);
	const [monthLabel, setmonthLabel] = useState();
	const [yearLabel, setyearLabel] = useState();
	const [dateLabel, setdateLabel] = useState();
	const [agentLabel, setagentLabel] = useState();
	const [weekLabel, setweekLabel] = useState();
	const [asOfDateLabel, setAsOfDateLabel] = useState();
	const [drNoFromLabel, setDrNoFromLabel] = useState();
	const [drNoToLabel, setDrNoToLabel] = useState();
	const [generatedReports, setGeneratedReports] = useState([]);
	const [latestGeneratedId, setLatestGeneratedId] = useState(null);
	const [disable, setDisable] = useState(true);
	const [getParamCustomer, setParamCustomer] = useState();
	const [getParamMonYear, setParamMonYear] = useState();
	const [getParamYear, setParamYear] = useState();
	const [getParamAgent, setParamAgent] = useState();
	const [getParamDate, setParamDate] = useState();
	const [getParamWeek, setParamWeek] = useState('');
	const [getParamGenerate, setParamGenerate] = useState([]);
	const [getParamAsOfDate, setParamAsOfDate] = useState();
	const userData = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
	const userID = userData.userID;

	useEffect(() => {
		async function fetchData() {
			setLoadingMessage('Loading reports...');
			setLoading(true);
			try {
				const messages = await fetchMessageListAPI();
				const dropDownReports = await fetchAccountingReportsAccessList(userID);

				setMessagesList(messages);
				setReportsList(dropDownReports);
			} finally {
				setLoading(false);
			}
		}
		fetchData();
	}, [userID]);

	useEffect(() => {
		const getCustomerLabel = params.filter(items => items.parameter_label === 'CUSTOMER');
		const getYearLabel = params.filter(par => par.parameter_label === 'YEAR');
		const getMonthLabel = params.filter(par => par.parameter_label === 'MON-YEAR');
		const getDateLabel = params.filter(par => par.parameter_label === 'SOA DATE');
		const getAgentLabel = params.filter(par => par.parameter_label === 'AGENT');
		const getWeekLabel = params.filter(par => par.parameter_label === 'WEEK NO');
		const getAsOfDateLabel = params.filter(par => par.parameter_label === 'AS OF DATE');
		const getDrNoFrom = params.filter(par => par.parameter_source === 'DR_NO_FROM');
		const getDrNoTo = params.filter(par => par.parameter_source === 'DR_NO_TO');

		setcustomerLabel(getCustomerLabel.length > 0 ? getCustomerLabel[0].parameter_label : undefined);
		setyearLabel(getYearLabel.length > 0 ? getYearLabel[0].parameter_label : undefined);
		setmonthLabel(getMonthLabel.length > 0 ? getMonthLabel[0].parameter_label : undefined);
		setdateLabel(getDateLabel.length > 0 ? getDateLabel[0].parameter_label : undefined);
		setagentLabel(getAgentLabel.length > 0 ? getAgentLabel[0].parameter_label : undefined);
		setweekLabel(getWeekLabel.length > 0 ? getWeekLabel[0].parameter_label : undefined);
		setAsOfDateLabel(getAsOfDateLabel.length > 0 ? getAsOfDateLabel[0].parameter_label : undefined);
		setDrNoFromLabel(getDrNoFrom.length > 0 ? getDrNoFrom[0].parameter_label : undefined);
		setDrNoToLabel(getDrNoTo.length > 0 ? getDrNoTo[0].parameter_label : undefined);
	}, [params]);

	// get reports list excluding module_code = 'DR'
	const reportsOptions = reportsList
	.filter(item => item.module_code !== 'DR')
	.map((item, index) => (
		<Option key={index} value={item.document_id}>
		{item.document_name}
		</Option>
	));

	async function handleSubmit(formValues) {
		const currentDate = new Date()
		const formatMonth = (currentDate.getMonth()+1) < 10 ? '0'+(currentDate.getMonth()+1) : (currentDate.getMonth()+1)
		const formatDate = currentDate.getDate() < 10 ? '0'+currentDate.getDate() : currentDate.getDate()

		const today = currentDate.getFullYear() + '-' + formatMonth + '-' + formatDate
		const auditPayload = {
			reportType,
			reportPrefix: selectedReportPrefix,
			formValues,
			parameters: {
				customer: getParamCustomer,
				monthYear: getParamMonYear,
				year: getParamYear,
				agent: getParamAgent,
				date: getParamDate,
				week: getParamWeek,
				asOfDate: getParamAsOfDate,
			},
		};

		try {
			setLoadingMessage('Generating report...');
			setLoading(true);
			let apiResp = {};
			switch(selectedReportPrefix) {
			case 'RPT_AR_PER_CLNT':
				apiResp = await generateArPerClient(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_AR_SUMM':
				apiResp = await generateArSummary(userID, today);
				break;
			case 'RPT_BIR_SALES':
				apiResp = await generateBirSalesRep(userID, formValues.dateRange);
				break;
			case 'RPT_COLL_PER_CLNT':
				apiResp = await generateColRepPerClient(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_COLL_PER_MTH':
				apiResp = await generateColRepPerMonth(userID, getParamMonYear);
				break;
			case 'RPT_COLL_PER_WK': {
				const fromTo = (getParamWeek || '').split('~');
				apiResp = await generateColRepPerWeek(userID, fromTo[0], fromTo[1]);
				break;
			}
			case 'RPT_COLL_SUMM':
				apiResp = await generateColRepSummary(userID, formValues.dateRange);
				break;
			case 'RPT_COMM_PER_AGNT':
			case 'RPT_COMM_PER_AGNT_MTH':
				apiResp = await generateRepAgentPerMonth(userID, getParamAgent, formValues.dateRange);
				break;
			case 'RPT_OR_SERIES_MONITOR':
				apiResp = await generateOrSeries(userID, formValues.dateRange);
				break;
			case 'RPT_SALES_PER_CLNT':
			case 'RPT_SALES_PER_CLNT_MTH':
				apiResp = await generateSalesRepPerClientMonth(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_SALES_PER_AGNT':
				apiResp = await generateSalesRepPerAgentMonth(userID, getParamCustomer, getParamAgent, formValues.dateRange);
				break;
			case 'RPT_SALES_PER_MTH_BRKDWN':
				apiResp = await generateSalesRepPerMonthBr(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_SOA':
				apiResp = await generateSoa(userID, getParamCustomer, getParamAgent, formValues.dateRange);
				break;
			case 'RPT_AR_AGING_PER_CLNT':
				apiResp = await generateArAgingPerClient(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_COLL_PER_PYMT':
				apiResp = await generateColRepPerPayDate(userID, formValues.dateRange);
				break;
			case 'RPT_AR':
				apiResp = await generateAr(userID, formValues.dateRange);
				break;
			case 'RPT_AR_AGING':
				apiResp = await generateArAging(userID, formValues.dateRange);
				break;
			case 'RPT_COLL':
				apiResp = await generateColReport(userID, formValues.dateRange);
				break;
			case 'RPT_SALES':
				apiResp = await generateSalesReport(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_DR_SERIES_MONITOR':
				apiResp = await generateDrSeries(userID, formValues.drNoFrom, formValues.drNoTo);
				break;
			case 'RPT_DR_UNBILLED':
				apiResp = await generateUnbilledDr(userID, formValues.dateRange);
				break;
			case 'RPT_DR_CLIENT_DELIVERY':
				apiResp = await generateDrClientDelivery(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_CONSOLIDATED_DATE_RANGE':
				apiResp = await generateConsolidatedDateRange(userID, formValues.dateRange);
				break;
			case 'RPT_CONSOLIDATED_CUSTOMER':
				apiResp = await generateConsolidatedCustomer(userID, getParamCustomer, formValues.dateRange);
				break;
			case 'RPT_CONSOLIDATED_AGENT':
				apiResp = await generateConsolidatedAgent(userID, getParamAgent, formValues.dateRange);
				break;
			case 'RPT_AR_CONSOLIDATED':
				apiResp = await generateArSummArPerClientCombined(userID, formValues.dateRange, getParamCustomer);
				break;
			default:
				Message.error({ message: `Unsupported report prefix: ${selectedReportPrefix || 'UNKNOWN'}` });
				return;
			}

			// console.log('apiResp => ' , apiResp);

			switch(apiResp.messageType) {
			case ('MESSAGE_SUCCESS'):
				Message.success({ message: apiResp.messageDisplay });
				void logAuditTrailEvent({
					moduleCode: 'rpt',
					subModuleCode: 'accounting_reports',
					action: 'GENERATE',
					description: `Generate report success: ${selectedReportPrefix || reportType}`,
					payload: { ...auditPayload, response: apiResp },
					isSuccess: 1,
				});

				const genReports = await fetchGeneratedReports(reportType); //to refresh search results
				setGeneratedReports(genReports);

				// Set the latest generated document ID to focus on it
				if (apiResp.data && apiResp.data.generated_document_id) {
					setLatestGeneratedId(apiResp.data.generated_document_id);
				} else if (genReports && genReports.length > 0) {
					// If no ID in response, use the first item (most recent)
					setLatestGeneratedId(genReports[0].generated_document_id);
				}

				break;
			case ('MESSAGE_ERROR'):
				Message.error({ message: apiResp.messageDisplay });
				void logAuditTrailEvent({
					moduleCode: 'rpt',
					subModuleCode: 'accounting_reports',
					action: 'GENERATE',
					description: `Generate report failed: ${selectedReportPrefix || reportType}`,
					payload: { ...auditPayload, response: apiResp },
					isSuccess: 0,
				});
				break;
			default :
			}
			
		} catch (error) {
			console.log('error', error);
			void logAuditTrailEvent({
				moduleCode: 'rpt',
				subModuleCode: 'accounting_reports',
				action: 'GENERATE',
				description: `Generate report exception: ${selectedReportPrefix || reportType}`,
				payload: { ...auditPayload, error: error && error.message },
				isSuccess: 0,
			});
		} finally {
			setLoading(false);
		}
	}

	function handleParameters(value) {
		setParamGenerate(value);
	}

	function paramCustomer(value) {
		setParamCustomer(value);
		// setDisable(false);
	}

	function paramAgent(value) {
		setParamAgent(value);
		// setDisable(false);
	}

	function paramMonYear(value) {
		setParamMonYear(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramYear(value) {
		setParamYear(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramDate(value) {
		setParamDate(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramWeek(value) {
		setParamWeek(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramAsOfDate(value){
		setParamAsOfDate(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramDateRange(value){
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramDrNoFrom(value){
		return value;
	}

	function paramDrNoTo(value){
		return value;
	}

	function clearSearch() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		const resetParameters = {
			// report: undefined,
			customer: undefined,
			asOfDate: undefined,
			monthYear: undefined,
			year: undefined,
			week: undefined,
			agent: undefined,
			date: undefined,
			drNoFrom: undefined,
			drNoTo: undefined
		};
		setFieldsValue(resetParameters);
		setParamCustomer(undefined);
		setParamMonYear(undefined);
		setParamYear(undefined);
		setParamAgent(undefined);
		setParamDate(undefined);
		setParamWeek(undefined);
		setParamGenerate([]);
		setParamAsOfDate(undefined);
		// setDisable(true);
	}

	async function handleReport(e) {
		if(e !== undefined || e !== ''){
			setDisable(false);
		}

		console.log('report e => ' , e);

		setLoading(true);
		setLoadingMessage('Loading report details...');
		try {
			setReportType(e);
			const selected = reportsList.find((item) => item.document_id === e);
			setSelectedReportPrefix(selected ? selected.file_name_prefix : '');

			const params = await fetchParams(e);
			setParams(params);

			const genReports = await fetchGeneratedReports(e);
			setGeneratedReports(genReports);

			form.resetFields();
		} finally {
			setLoading(false);
		}
	}

	useEffect(()=> {
		const { setFieldsValue } = formRef.current;
		const resetParameters = {
			// report: undefined,
			dateRange: undefined,
			customer: undefined,
			asOfDate: undefined,
			monthYear: undefined,
			year: undefined,
			week: undefined,
			agent: undefined,
			date: undefined,
			drNoFrom: undefined,
			drNoTo: undefined
		}

		setFieldsValue(resetParameters);
		setParamCustomer(undefined);
		setParamMonYear(undefined);
		setParamYear(undefined);
		setParamAgent(undefined);
		setParamDate(undefined);
		setParamWeek(undefined);
		setParamGenerate([]);
		setParamAsOfDate(undefined);
	}, [reportType]);

	return (
		<Spin spinning={loading} tip={loadingMessage} size="large">
		<div style={{ minHeight: 320 }}>
			<Form layout="vertical" onFinish={handleSubmit} ref={formRef}>
				<Row gutter={[8, 1]} align="bottom">
					<Col span={8} className="gutter-row">
						<Form.Item label="REPORT" name="report" rules={[{ required: true, message: 'Required Field' }]}>
							<Select
								placeholder="REPORT"
								showSearch
								onSelect={handleReport}
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
								// onChange={handleOnChangeReport}
							>
								{reportsOptions}
							</Select>
						</Form.Item>
					</Col>
					<Col span={8}></Col>
					<Col span={8} style={{ textAlign: 'right' }}>
						<Button
							className="login-form-button inv-button"
							type="primary"
							htmlType="submit"
							disabled={disable || loading}
						>
							GENERATE
						</Button>
						<Button className="form-button inv-button-right" onClick={clearSearch} disabled={loading}>
							CLEAR
						</Button>
					</Col>
				</Row>
				<SearchLov
					showReport={params}
					customerLabel={customerLabel === undefined ? 'NA' : customerLabel}
					yearLabel={yearLabel === undefined ? 'NA' : yearLabel}
					monthLabel={monthLabel === undefined ? 'NA' : monthLabel}
					dateLabel={dateLabel === undefined ? 'NA' : dateLabel}
					agentLabel={agentLabel === undefined ? 'NA' : agentLabel}
					weekLabel={weekLabel === undefined ? 'NA' : weekLabel}
					asOfDateLabel={asOfDateLabel === undefined ? 'NA' : asOfDateLabel}
					drNoFromLabel={drNoFromLabel === undefined ? 'DR NO FROM' : drNoFromLabel}
					drNoToLabel={drNoToLabel === undefined ? 'DR NO TO' : drNoToLabel}
					reportType={reportType}
					// setDisable={disable}
					handleParameters={handleParameters}
					paramCustomer={paramCustomer}
					paramAgent={paramAgent}
					paramMonYear={paramMonYear}
					paramYear={paramYear}
					paramDate={paramDate}
					paramWeek={paramWeek}
					paramAsOfDate={paramAsOfDate}
					paramDateRange={paramDateRange}
					paramDrNoFrom={paramDrNoFrom}
					paramDrNoTo={paramDrNoTo}
				/>
			</Form>
			<SearchReportTable data={generatedReports} latestGeneratedId={latestGeneratedId} />
		</div>
		</Spin>
	);
}

export default SearchReportForm;
